module.exports = __webpack_public_path__ + "8df02a8272370da57bd826f62f58d353.png";